import React from 'react';
import { Box, Container, Typography, Paper, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';

export const CreditsSuccessPage: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 6, textAlign: 'center' }}>
        <CheckCircleIcon sx={{ fontSize: 80, color: 'success.main', mb: 3 }} />

        <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
          Payment Successful!
        </Typography>

        <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
          Your credits have been added to your account.
        </Typography>

        <Box sx={{ bgcolor: 'success.light', p: 3, borderRadius: 2, mb: 4, border: '2px solid', borderColor: 'success.main' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 1 }}>
            <RefreshIcon color="success" />
            <Typography variant="body1" sx={{ fontWeight: 700, color: 'success.dark' }}>
              Important: Refresh Required
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ color: 'success.dark' }}>
            Close this tab and click the <strong>Refresh</strong> button on the Credits page in the GovToolsPro extension to see your updated balance.
          </Typography>
        </Box>

        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => window.close()}
          sx={{ minWidth: 200 }}
        >
          Close This Tab
        </Button>
      </Paper>
    </Container>
  );
};
